/** @jsx jsx */

import { Dropdown, Text } from '@zapier/design-system';
import { jsx } from '@emotion/react';

import { ALL_VERSIONS_OPTION } from './constants';

import type { SemVer } from 'app/developer-v3/types/version';

const Styles = {
  root: {
    alignItems: 'center',
    display: 'inline-flex',
  },
  version: {
    minWidth: 150,
  },
};

type Props = {
  hasAllVersions?: boolean;
  initialVersion: SemVer;
  isLabelVisible?: boolean;
  onChange: (versionNext: SemVer) => void;
  placeholder?: string;
  versions: Array<string>;
};

const defaultProps = {
  hasAllVersions: true,
  isLabelVisible: false,
  placeholder: 'Select version',
};

function VersionPicker({
  hasAllVersions = defaultProps.hasAllVersions,
  initialVersion,
  isLabelVisible = defaultProps.isLabelVisible,
  onChange,
  placeholder = defaultProps.placeholder,
  versions,
}: Props) {
  const items = hasAllVersions
    ? [ALL_VERSIONS_OPTION, ...versions.map(v => ({ label: v, value: v }))]
    : versions.map(v => ({ label: v, value: v }));

  return (
    <div css={Styles.root}>
      {isLabelVisible && (
        <Text margin="0 8px 0 0" tag="span" type="Body3">
          Version:
        </Text>
      )}
      <div css={Styles.version}>
        <Dropdown
          aria-label="List of available versions"
          getLabelForItem={item => item.label}
          initialSelectedItem={items.find(
            ({ value }) => value === initialVersion
          )}
          items={items}
          onChange={item => onChange(item.value)}
          placeholder={placeholder}
          size="medium"
        />
      </div>
    </div>
  );
}

VersionPicker.defaultProps = defaultProps;

export default VersionPicker;
